import { useCallback } from "react";
import { useDialog } from "../../../../../../context";

const useHandleRemoveFile = (getValues, remove, update) => {
  const { showConfirm } = useDialog();

  const callRemoveFile = useCallback(
    async (index) => {
      await remove(index);
      const currentValues = getValues("floorPlans");

      let isRoof = [...currentValues].some((item) => item.isRoof) ? 1 : 0;
      const updatedFields = [...currentValues].map((item, idx, arr) => {
        const newItem = { ...item };
        if (newItem.isLabelCustom || item.isRoof) {
          if (item.isRoof) {
            isRoof = 0;
          }
          return newItem;
        }
        const label = `Floor ${arr.length - isRoof - idx}`;
        newItem.label = label;
        return newItem;
      });

      // Push updated data to form state
      updatedFields.forEach((item, idx) => update(idx, item));
    },
    [remove, update, getValues]
  );

  return async (index) => {
    const currentValues = getValues("floorPlans"); // 👈 fresh values
    let updatedFields = [...currentValues];
    const selected = { ...updatedFields[index] };
    if (selected.uploading && typeof selected.cancelUpload === "function") {
      selected.cancelUpload();
    } else if (selected.serverId) {
      showConfirm(
        "Deleting this floor will also remove all drones deployed on it.",
        "Are you sure you want to proceed?",
        () => callRemoveFile(index)
      );
    } else {
      callRemoveFile(index);
    }
  };
};

export default useHandleRemoveFile;
